// extracted by mini-css-extract-plugin
module.exports = {"button":"Brands_button__20T4l","addButton":"Brands_addButton__34-GM"};